import React from 'react';
import ICEmptyBox from "res/images/empty_box.png";

export default function EmptyBox(props) {
    return (
        <center>
            <div className="card_gray fullInMobileHalfInPc paddingSmall">
                <div>
                    <img className="xxLargeIcon" src={props.showImage ? props.showImage : ICEmptyBox} alt=""/>

                    <p className="largeTextBold">
                        {props.message}
                    </p>

                    <center className="largeTextBold">
                        <table>
                            <tbody>
                            <tr className="fullWidth">
                                <td>
                                    {props.subMessageMain}
                                </td>
                                <td>
                                    {props.icon}
                                </td>
                                <td>
                                    {props.subMessage}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </center>
                </div>
            </div>
        </center>
    )
}